//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    data() {
      return {
        isShow: false,
        name: '',
        mobile: '',
      };
    },
    methods: {
      showModalName() {
        this.isShow = true;
      },
      closeModel() {
        this.isShow = false;
        this.name = '';
        this.mobile = '';
      },
//      name mobile
      submission() {
        this.$emit('set-object', {
          name: this.name,
          mobile: this.mobile
        });
      },
    }
  };



// WEBPACK FOOTER //
// ./src/components/ModelName.vue